import { JSX } from 'preact';
import clsx from 'clsx';

export type CardProps = JSX.IntrinsicElements['div'];

export function Card({ className, children, ...props }: CardProps) {
  return (
    <div {...props} class={clsx('card', className)}>
      {children}
    </div>
  );
}
